export function getNewsTabs(pathname: string) {
  if (pathname.includes('operations')) {
    return ('OP');
  }
  if (pathname.includes('office')) {
    return ('BO');
  }
  if (pathname.includes('tech')) {
    return ('IT');
  }
  if (pathname.includes('common')) {
    return ('null');
  }
  return 'all';
}
